import {ActionAbstract} from './action.abstract';
import {ActionType} from '../../enums/action-type.enum';
import TimeModel from '../time.model';
import {FrameService} from '../../modules/shared/services/frame.service';
import {Store} from '@ngrx/store';
import VideoState from '../../modules/shared/stores/root-store/video.state';
import {JumpToSceneAction} from '../../modules/shared/stores/root-store/actions/video.action';
import {VideoStateEnum} from '../../enums/video-state.enum';

export class JumpToAction extends ActionAbstract {
    time: TimeModel;

    constructor(time: TimeModel) {
        super(ActionType.JumpTo);
        this.time = time;
    }

    getFrameToPerform(frameService: FrameService) {
        return frameService.getFloorFrame(this.time.start);
    }

    performAction(store: Store<{ video: VideoState }>, frameService: FrameService) {
        store.dispatch(JumpToSceneAction({
            navigationTime: this.getNewTime(frameService),
            videoState: VideoStateEnum.Playing
        }));
    }

    private getNewTime(frameService: FrameService) {
    // After investigation mediaconvert added additional time around 0.1 frame time when joining clip
    // and 1 frame is added to make sure next clip is displayed
        const additionalFrame = frameService.getRoundFrame(this.time.end) + 1.1;

        return frameService.getTimeFromFrame(additionalFrame);
    }
}
